import React, { useEffect, useMemo, useState } from "react";
import { Button, Modal, ModalBody, Row, Table } from "reactstrap";

import { confirm } from "components/Confirmation";
import ordemServicoService from "services/OrdemServicoService";
import { StatusCorrecaoEquipeEnum } from "services/OrdemServicoService";
import comboService from "services/ComboService";
import { showLoading } from "components/Loading";
import { hideLoading } from "components/Loading";
import { toast } from "react-toastify";
import { erroInesperado } from "services/Utils";
import "./modalAtribuirEquipeExecucao.scss";

export default function ModalAtribuirEquipeCorrecao({ config, onClosed, onChange }) {
  const [idEquipe, setIdEquipe] = useState()
  const [equipes, setEquipes] = useState([])
  const [itensSelecionados, setItensSelecionados] = useState([])

  useEffect(() => {
    if (config?.idOrdemServico) {
      comboService.equipes().then(res => {
        if (res.success) {
          setEquipes(res.data)
        }
      })
    } else {
      setEquipes([])
    }
    setIdEquipe()
    setItensSelecionados([])
  }, [config?.idOrdemServico])

  const itensDisponiveis = useMemo(() => config?.itens || [], [config?.itens])

  const correcaoNaoFinalizadaDaEquipe = useMemo(() => {
    if (!idEquipe) return null

    return (config?.correcoes || []).find(co => co.idEquipe == idEquipe && co.status != StatusCorrecaoEquipeEnum.FINALIZADA) || null
  }, [config?.correcoes, idEquipe])

  const handleConfirmar = () => {
    confirm({
      text: 'Você deseja atribuir estes itens para as equipes selecionadas?',
      icon: 'bi-exclamation-triangle',
      onConfirm: async () => {
        showLoading()
        try {
          await ordemServicoService.atribuirCorrecao(config.idOrdemServico, idEquipe, itensSelecionados)
          onChange && onChange()
          onClosed && onClosed()
          hideLoading()
        } catch (ex) {
          console.log(ex)
          hideLoading()
          if ([400, 409].includes(ex.status) && ex?.response?.data?.message) {
            toast(ex?.response?.data?.message)
            return
          }
          erroInesperado()
        }
      }
    })
  }

  const handleSelecionarItem = (idItem) => {
    if (itensSelecionados.includes(idItem)) {
      setItensSelecionados(itensSelecionados.filter(id => id !== idItem))
      return
    }

    setItensSelecionados([...itensSelecionados, idItem])
  }

  return (
    <Modal isOpen={!!config} size="lg">
      <ModalBody>
        {(config) && (
          <>
            <h2>Atribuir Equipe de Correção</h2>
            <hr />
            <Row>
              <div className="col-12 col-md-8">
                <div className="form-group">
                  <label htmlFor="idEquipeCorrecao">Equipe</label>
                  <select id="idEquipeCorrecao" className="form-control" value={idEquipe || ''} onChange={ev => ev.target.value == '' ? setIdEquipe() : setIdEquipe(+ev.target.value)}>
                    <option value="">Selecione</option>
                    {equipes.map(el => (
                      <option key={el.id} value={el.id}>{el.nome}</option>
                    ))}
                  </select>
                </div>
              </div>
            </Row>
            <div className="mt-4">
              <h4>Selecione os itens</h4>
              <Table bordered className="mb-0 tabela-itens-atribuicao">
                <thead className="thead-itens-atribuicao">
                  <tr>
                    <th className="col-checkbox">&nbsp;</th>
                    <th>Item</th>
                  </tr>
                </thead>
                <tbody>
                  {itensDisponiveis.map(it => {
                    const inputId = `item-correcao-${it.id}`

                    return (
                      <tr key={it.id}>
                        <td className="text-center align-middle">
                          <input
                            id={inputId}
                            type="checkbox"
                            checked={itensSelecionados.includes(it.id)}
                            onChange={() => handleSelecionarItem(it.id)}
                          />
                        </td>
                        <td className="align-middle">
                          <label htmlFor={inputId} className="mb-0 label-item-atribuicao">
                            {it.codigo} - {it.descricao}
                          </label>
                        </td>
                      </tr>
                    )
                  })}
                  {itensDisponiveis.length == 0 && (
                    <tr>
                      <td colSpan={2}>Nenhum item pendente de atribuição.</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
            {correcaoNaoFinalizadaDaEquipe && (
              <div className="text-muted mt-2 small">
                Esta equipe já possui correção em andamento. Os itens selecionados serão adicionados à correção existente.
              </div>
            )}
            <div className="row mt-4">
              <div className="col-12 text-right">
                <Button color="primary" onClick={handleConfirmar} disabled={!idEquipe || itensSelecionados.length == 0}>Atribuir Itens à Equipe</Button>
                <Button color="primary" onClick={onClosed} outline>Cancelar</Button>
              </div>
            </div>
          </>
        )}
      </ModalBody>
    </Modal>
  )
}